<div class="copo-datacenter-filter">
	<button type="button" class="reset-button" *ngIf="filterValue && filterValue.code" matSuffix mat-icon-button
		(click)="resetFilter();" tabindex="-1">
		<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
	</button>
	<div class="filter-number-label">{{this.header}}</div>
	<div class="filter-container">
		<mat-form-field appearance="outline" class="copo-no-error-message">
			<input matInput [matAutocomplete]="auto" [formControl]="searchTextControl"
				[placeholder]="this.header + '...'" [attr.aria-label]="this.header" />
			<copo-loading-spinner matSuffix class="loading-spinner-container-input" *ngIf="isLoading"></copo-loading-spinner>
			<!-- About ag-custom-component-popup: https://www.ag-grid.com/javascript-data-grid/component-filter/#custom-filters-containing-a-popup-element-->
			<mat-autocomplete #auto="matAutocomplete" class="ag-custom-component-popup">
				<mat-option *ngFor="let filterItem of filteredItems | async"
					(onSelectionChange)="propositionChanged(filterItem)">
					{{ filterItem.translation }}
				</mat-option>
			</mat-autocomplete>
		</mat-form-field>
	</div>
</div>